
import { Link } from "react-router-dom";
import {
  Sidebar,
  SidebarHeader,
  SidebarContent,
} from "@/components/ui/sidebar";
import { StaffSidebarItems } from "./StaffSidebarItems";
import { AdminSidebarItems } from "./AdminSidebarItems";

interface StaffSidebarProps {
  isAdmin: boolean;
}

export const StaffSidebar = ({ isAdmin }: StaffSidebarProps) => {
  console.log("StaffSidebar - Rendering with isAdmin:", isAdmin);
  
  return (
    <Sidebar>
      <SidebarHeader className="flex items-center justify-center p-4">
        <Link to="/home" className="flex items-center">
          <img
            src="/lovable-uploads/21086736-4e89-4e97-93a1-7f8113b89223.png"
            alt="Forge Medical Practice Logo"
            className="h-8 mr-2"
          />
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <StaffSidebarItems isAdmin={isAdmin} />
        {isAdmin && <AdminSidebarItems />}
      </SidebarContent>
    </Sidebar>
  );
};
